import { ref, reactive } from 'vue'
import { mobileCmsMemberApplicationAPI } from '@/services/axios/perki/mobileCms'

const STATUS_CONFIG = {
  pending: { label: 'Verifikasi Admin', color: 'blue' },
  revision: { label: 'Menunggu Revisi', color: 'orange' },
  approved: { label: 'Disetujui', color: 'green' },
  rejected: { label: 'Ditolak', color: 'red' },
}

export function useMemberApplication(initialStatus) {
  const loading = ref(false)
  const applications = ref([])
  const searchQuery = ref('')
  const statusFilter = ref(initialStatus || '')
  const cabangFilter = ref('')

  const sortField = ref('createdAt')
  const sortOrder = ref('desc')

  const pagination = reactive({
    current: 1,
    pageSize: 10,
    total: 0,
    showTotal: total => `Menampilkan ${pagination.pageSize} dari ${total} baris`,
  })

  const statusFilterOptions = Object.entries(STATUS_CONFIG).map(([value, config]) => ({
    text: config.label,
    value,
  }))

  const getStatusConfig = status => STATUS_CONFIG[status] || { label: status, color: 'default' }

  const loadApplications = async () => {
    loading.value = true
    try {
      const params = {
        page: pagination.current,
        pageSize: pagination.pageSize,
        search: searchQuery.value || undefined,
        sortBy: sortField.value,
        sortOrder: sortOrder.value,
      }
      if (statusFilter.value) params.status = statusFilter.value
      if (cabangFilter.value) params.perkiCabang = cabangFilter.value

      const res = await mobileCmsMemberApplicationAPI.getAll(params)
      const result = res.data.result
      applications.value = result.data || []
      pagination.total = result.totalData || 0
      console.log('Loaded applications:', applications.value.length)
    } catch (err) {
      console.error('Failed to load applications:', err)
    } finally {
      loading.value = false
    }
  }

  const handleTableChange = (pag, _filters, sorter) => {
    if (pag) {
      pagination.current = pag.current || pagination.current
      pagination.pageSize = pag.pageSize || pagination.pageSize
    }
    if (sorter && sorter.field) {
      sortField.value = sorter.field
      sortOrder.value = sorter.order === 'descend' ? 'desc' : 'asc'
    } else if (sorter && !sorter.order) {
      sortField.value = 'createdAt'
      sortOrder.value = 'desc'
    }
    loadApplications()
  }

  const handleSearch = () => {
    pagination.current = 1
    hasInitialized.value = true
    loadApplications()
  }

  const handleStatusFilter = val => {
    statusFilter.value = val || ''
    pagination.current = 1
    loadApplications()
  }

  const handleCabangFilter = val => {
    cabangFilter.value = val || ''
    pagination.current = 1
    loadApplications()
  }

  const clearCabangFilter = () => {
    cabangFilter.value = ''
    pagination.current = 1
    loadApplications()
  }

  return {
    loading,
    applications,
    searchQuery,
    statusFilter,
    cabangFilter,
    sortField,
    sortOrder,
    pagination,
    getStatusConfig,
    loadApplications,
    handleTableChange,
    handleSearch,
    handleStatusFilter,
    handleCabangFilter,
    clearCabangFilter,
  }
}
